// extracted by css-extract-rspack-plugin
export default {"root":"root-f48Mvx"};